import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";

import Layout from "./Layout";

import Home from "./pages/Home";
import About from "./pages/About";
import Members from "./pages/Members";
import Activities from "./pages/Activities";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Partners from "./pages/Partners";
import ActivityRegister from "./pages/ActivityRegister";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";

import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminSubs from "./admin/AdminSubs";
import AdminNotifications from "./admin/AdminNotifications";
import AdminNewsletter from "./admin/AdminNewsletter";
import InscriptionAdmin from "./admin/InscriptionAdmin";
import MemberDetails from "./admin/MemberDetails";
import AdminMembers from "./admin/AdminMembers";
import EditMember from "./admin/EditMember";
import Presences from "./admin/Prsc";
import ScanPresence from "./admin/Chercher";
import PresencesHistory from "./admin/PsHistoire";
import AdminWelcome from "./admin/AdminWelcome";
import AdminActivities from "./admin/AdminActivities";
import AdminActivityEdit from "./admin/AdminActivityEdit";

import MembreLayout from "./pages/membre/MembreLayout";
import MembreLogin from "./pages/membre/Login";
import ForgotPassword from "./pages/membre/ForgotPassword";
import VerifyCode from "./pages/membre/VerifyCode";
import ResetPassword from "./pages/membre/ResetPassword";
import ChangeFirstPassword from "./pages/membre/ChangeFirstPassword";

import MembreDashboard from "./pages/membre/Dashboard";
import MembreProfile from "./pages/membre/Profile";
import ChangePassword from "./pages/membre/ChangePassword";
import History from "./pages/membre/Histoire";
import EditProfile from "./pages/membre/EditProfile";

import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-center" autoClose={2000} />
      <ScrollToTop />

      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/members" element={<Members />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/partners" element={<Partners />} />
          <Route
            path="/membre/activity/register/:activityId"
            element={<ActivityRegister />}
          />

          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
        </Route>

        <Route path="/membre/login" element={<MembreLogin />} />
        <Route path="/membre/forgot" element={<ForgotPassword />} />
        <Route path="/membre/verify" element={<VerifyCode />} />
        <Route path="/membre/reset" element={<ResetPassword />} />
        <Route path="/membre/change-first" element={<ChangeFirstPassword />} />

        <Route path="/membre" element={<MembreLayout />}>
          <Route path="dashboard" element={<MembreDashboard />} />
          <Route path="profile" element={<MembreProfile />} />
          <Route path="edit-profile" element={<EditProfile />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="history" element={<History />} />
        </Route>

        <Route
          path="/admin/welcome"
          element={
            <ProtectedAdminRoute>
              <AdminWelcome />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="subs" element={<AdminSubs />} />
          <Route path="newsletter" element={<AdminNewsletter />} />
          <Route path="notifications" element={<AdminNotifications />} />
          <Route path="inscriptions" element={<InscriptionAdmin />} />
          <Route path="members" element={<AdminMembers />} />
          <Route path="edit-member/:id" element={<EditMember />} />
          <Route path="member-details/:id" element={<MemberDetails />} />
          <Route path="scan" element={<ScanPresence />} />
          <Route path="activities" element={<AdminActivities />} />
          <Route path="activities/edit/:id" element={<AdminActivityEdit />} />
          <Route path="presences" element={<Presences />} />
          <Route path="presences-history" element={<PresencesHistory />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
